import { makeObservable, observable, runInAction } from 'mobx';
import Store from './Store';
import { LOCALSTORAGE_STORAGE } from '@/util/StorageUtil';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */

export default class ParametroStore extends Store {
    parametros = [];
    featuresFlags = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            parametros: observable,
            featuresFlags: observable
        });
    }

    get storageType() {
        return LOCALSTORAGE_STORAGE;
    }

    async inicializar() {
        super.inicializar();
        let parametros = await this.secretariaService.recuperarParametros();
        runInAction(() => (this.parametros = parametros));

        let featuresFlags = await this.secretariaService.recuperarFeaturesFlags();
        runInAction(() => (this.featuresFlags = featuresFlags));
    }

    getParametro(chave) {
        return this.parametros.find((parametro) => parametro.chave === chave);
    }

    getParametros(chave) {
        return this.parametros.filter((parametro) => parametro.chave === chave);
    }

    getParametrosIgnoreCase(chave) {
        chave = chave || '';
        return this.parametros.filter(
            (parametro) => parametro.chave.toLowerCase().trim() === chave.toLowerCase().trim()
        );
    }

    getParametroPeloValor(valor) {
        return this.parametros.find((parametro) => parametro.valor === valor);
    }

    getTiposParametros() {
        let tiposParametros = [];
        this.parametros.forEach((parametro) => {
            if (!tiposParametros.find((p) => p.id === parametro.tipo.id && p.descricao === parametro.tipo.descricao)) {
                tiposParametros.push(parametro.tipo);
            }
        });
        return tiposParametros.sort((a, b) => {
            return a.id - b.id;
        });
    }

    get isOrgaoTST() {
        const nomeParametro = 'SIGLA_ORGAO';
        let parametro = this.getParametroObrigatorio(nomeParametro);
        return parametro.valor === 'TST' || parametro.valor === 'TRT';
    }

    get ufOrgao() {
        const nomeParametro = 'UF_ORGAO';
        let parametro = this.getParametroObrigatorio(nomeParametro);
        return parametro.valor;
    }

    getParametroObrigatorio(nomeParametro) {
        let parametro = this.getParametro(nomeParametro);

        if (parametro === undefined) {
            throw new Error('Parâmetro ' + nomeParametro + ' não cadastrado.');
        }

        return parametro;
    }

    isComponenteHabilitado(nomeComponente) {
        let featureFlag = this.featuresFlags.find((feature) => feature.nome === nomeComponente);
        return !featureFlag || featureFlag.valor === true;
    }

    usaCertidao() {
        let parametro = this.getParametro('usaCertidao');
        return parametro && parametro.valor === 'true';
    }
}
